<template>
    <div class="k-checkbox" :class="{'hide-details': hideDetails}">
        <v-checkbox
            :id="id"
            v-model="value"
            :label="label"
            :color="color"
            :disabled="disabled"
        ></v-checkbox>
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed } from 'vue';

interface IOwnProps {
    label?: string
    modelValue?: any
    color?: string
    disabled?: boolean
    hideDetails?: boolean
    id?: string
}

interface IProps extends IOwnProps {
}

const props = defineProps<IProps>();
const emit = defineEmits(['update:modelValue']);

const value = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
});
</script>

<style scoped lang="scss">
.k-checkbox {
    display: flex;
    align-items: center;
    width: max-content;
    height: 30px;
    margin-left: -12px;

    &:deep(.v-selection-control__input) {
        color: $primary-400;
    }

    &:deep(.v-selection-control__wrapper) {
        height: 30px;
    }

    &:deep(.v-input--density-default) {
        --v-input-control-height: 30px;
    }

    &:deep(label) {
        font-size: 14px;
    }
}

.hide-details {
    &:deep(.v-input__details) {
        display: none;
    }
}
</style>
